module.exports = __webpack_public_path__ + "static/media/vibrant-4.dfb71549.png";